import React from 'react';
import { AuthProvider } from '../contexts/AuthContext.js';
import { SubscriptionProvider } from '../contexts/SubscriptionContext.js';
import { ContentProvider } from '../contexts/ContentContext.js';
import { SafetyProvider } from '../contexts/SafetyContext.js';
import { ProgressProvider } from '../contexts/ProgressContext.js';

// Comment out or conditionally include providers that might not exist
// import { SafetyProvider } from './SafetyProvider';
// import { SchedulingProvider } from './SchedulingProvider';

export const AppProviders = ({ children }) => {
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <ProgressProvider>
          <ContentProvider>
            <SafetyProvider>
              {/* Temporarily remove the missing providers */}
              {children}
            </SafetyProvider>
          </ContentProvider>
        </ProgressProvider>
      </SubscriptionProvider>
    </AuthProvider>
  );
};